import React, { memo, forwardRef } from 'react';
import styles from './button.module.scss';
import cn from 'classnames';


export interface ButtonProps {
	value: string
	onClick?: (event:React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onMouseEnter?: () => void;
  onMouseOut?: () => void; 
	mode?: string
	type?: 'button' | 'submit'
	id?: string
  disabled?: boolean;
  icon?: string;
  customStyles?: Record<string, string>;
};

export const Button = memo(forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { value, onClick, mode = 'default', type = 'button', id = '', disabled, icon, customStyles, onMouseEnter, onMouseOut } = props;

  return (
    <button 
      id={id}
      ref={ref} 
      className={cn(styles[mode], styles[`icon-${icon}`], { [styles["icon"]]: icon })} 
      onClick={onClick} 
      type={type}
      disabled={disabled}
      style={customStyles}
      onPointerEnter={onMouseEnter}
      onPointerOut={onMouseOut}
    >
      {value}
    </button>
  );		
}));